<template>
  <li 
    class="mb-4"
    :class="{
      'pr-24' : item.status !== 'Submitted',
      'pl-24' : item.status === 'Submitted'
    }"
  >
    <component 
      :is="requestType"
      :item="item" 
    />
    <p 
      class="mt-1 text-2xs text-grey-800 italic"
      :class="{
        'text-right' : item.status === 'Submitted'
      }"
      v-html="stamp"
    />
  </li>
</template>

<script>
import {format, parseISO} from 'date-fns'
export default {
  name: 'LogListItem',
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  computed: {
    requestType() {
      return 'log-listing-item-' + this.item.type.replace('_', '-');
    },
    date() {
      return format( parseISO(this.item.created_at), 'do MMMM yyyy HH:mm')
    },
    stamp() {
      return this.item.user.role === 'user'
              ? `${ this.date }<b> / ${ this.item.created_by }</b>`
              : `<b>${ this.item.user.name } / </b> ${ this.date }`
    }
  }
}
</script>